<ng-template #popupTemplate>
  <div
    class="sign-simulation-popup position-relative p-3 rounded text-break rounded-2 text-lightgray bg-card bg-dark border border-darkgray"
    style="min-width: 600px"
  >
    <span
      class="rb-ic rb-ic-close fs-2xl position-absolute top-2 end-2 cursor-pointer hover-effect"
      (click)="popup.remove()"
    ></span>

    <div class="row g-3 align-items-end">
      <span class="fs-lg text-body-emphasis">Create observations:</span>
      <div [ngClass]="canBeDigital() ? 'col-md-3' : 'col-md-6'">
        <label for="signTypeSelect" class="form-label">Sign type:</label>
        <select
          id="signTypeSelect"
          class="form-select text-lightgray bg-darkgray border border-darkgray"
          [(ngModel)]="popupSignType"
          (change)="onPopupSignTypeChange()"
        >
          @for (sign of signTypes; track sign) {
            <option [value]="sign">{{ sign }}</option>
          }
        </select>
      </div>

      @if (popupSignType.startsWith('SPEED_LIMIT')) {
        <div class="col-md-3">
          <label for="speedInput" class="form-label">Speed:</label>
          <input
            id="speedInput"
            type="number"
            class="form-control text-lightgray bg-darkgray border border-darkgray"
            [(ngModel)]="popupSpeedValue"
            (change)="onPopupSpeedChange()"
            [min]="isZoneSign() ? 20 : 10"
            [max]="isZoneSign() ? 30 : 130"
            step="10"
          />
        </div>
      }

      <div class="col-md-3">
        <label for="bearingInput" class="form-label">Bearing:</label>
        <input
          id="bearingInput"
          type="number"
          class="form-control text-lightgray bg-darkgray border border-darkgray"
          [(ngModel)]="popupBearing"
          (change)="onPopupBearingChange()"
          min="0"
          max="359"
          step="5"
        />
      </div>

      @if (canBeDigital()) {
        <div class="col-md-3">
          <label for="signDisplayType" class="form-label">Display type:</label>
          <select
            id="signDisplayType"
            class="form-select text-lightgray bg-darkgray border border-darkgray"
            [(ngModel)]="selectedSignDisplayType"
            (change)="onPopupDisplayTypeChange()"
          >
            @for (signDisplayType of signDisplayTypes; track signDisplayType) {
              <option value="{{ signDisplayType }}">{{ signDisplayType }}</option>
            }
          </select>
        </div>
      }
    </div>

    <div class="row mt-3">
      <div class="col">
        <label for="supplementarySelect" class="form-label">Supplementary signs:</label>
        <select
          id="supplementarySelect"
          class="form-select text-lightgray bg-darkgray border border-darkgray"
          multiple
          [(ngModel)]="popupSupplementarySigns"
          (change)="onPopupSupplementaryChange()"
        >
          @for (sup of supplementarySignTypes; track sup) {
            <option [value]="sup">{{ sup }}</option>
          }
        </select>
        @if (popupSupplementarySigns.length) {
          <div class="mt-2">
            @for (sup of popupSupplementarySigns; track sup) {
              <span
                class="badge bg-darkgray me-1"
                style="cursor: pointer"
                (click)="removeSupplementarySign(sup)"
                title="Remove"
              >
                {{ sup }} <span class="ms-1">&times;</span>
              </span>
            }
          </div>
        }
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-end gap-2 mt-3">
      <div>
        <label for="observationSourceSelect" class="form-label mb-1">Source:</label>
        <select
          id="observationSourceSelect"
          class="form-select text-lightgray bg-darkgray border border-darkgray"
          [(ngModel)]="popupSource"
        >
          @for (source of sourceOptions; track source) {
            <option [value]="source">{{ source }}</option>
          }
        </select>
      </div>
      <button
        type="button"
        class="rb-btn rb-btn-primary"
        [disabled]="!popupSource"
        (click)="simulateObservation()"
      >
        Create observation
      </button>
    </div>
  </div>
</ng-template>
